export enum IbcTankTypeEnum {
    Unknown,
    Type1G,
    Type2G,
    Type1P,
    Type2P
}